import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react";
import AddTournamentUmpire from "./components/addTournamentUmpire";
import Common from "../../../helper/common";
import { Button } from "../../../components/ui/button";
import AdvanceTable from "../../../components/advanceTable";
import { ViewDateTimeFormat } from "../../../constants/appConstant";
import { useQueryParams } from "../../../contexts/queryParamsContext";

const TournamentUmpires = () => {
  const [data, setData] = useState({});
  const [open, setOpen] = useState(false);
  const [refId, setRefId] = useState(null);

  useEffect(() => {
    getData(1);
  }, []);

  useEffect(() => {
    if (!open) {
      setRefId();
    }
  }, [open]);

  const getData = async (
    pageNumber,
    searchTerm = "",
    recordsToDisplay = null
  ) => {
    const response = await Common.ApiService.getInstance().request(
      "GetTournamentUmpires",
      {
        pageNumber: pageNumber,
        q: searchTerm,
        recordsToDisplay,
      },
      "POST"
    );
    if (response?.data) {
      let obj = {
        ...response.data[0],
        data: response.data[0].data.map((item) => ({
          ...item,
          lastLogin: item.lastLogin
            ? `${Common.moment(item.lastLogin).format(ViewDateTimeFormat)}`
            : "-",
          createdOn: item.createdOn
            ? `${Common.moment(item.createdOn)
                .add(5, "hours")
                .format(ViewDateTimeFormat)}`
            : "-",
          name: `${item.firstName} ${item.lastName}`,
          phone: item.phoneCode
            ? `${item.phoneCode} ${item.phoneNumber}`
            : item.phoneNumber,
        })),
      };

      setData(obj);
    }
  };

  const _handleDelete = async (id) => {
    const isConfirmed = await Common.SweetAlert.confirmation(
      "Are you sure you want to delete this Tournament Umpire?",
      "Delete Tournament Umpire"
    );
    if (isConfirmed) {
      let resp = await Common.ApiService.getInstance().request(
        `DeleteTournamentUmpire?id=${id}`,
        {},
        "Delete"
      );
      Common.SweetAlert.alert(resp.message, "success");
      setTimeout(() => {
        getData(1);
      }, 500);
    }
  };

  const _onEdit = async (id) => {
    setOpen(true);
    setRefId(id);
  };

  const actions = [
    {
      type: "edit",
      onClick: (val) => {
        _onEdit(val.id);
      },
    },
    {
      type: "delete",
      onClick: (val) => _handleDelete(val.id),
    },
  ];

  let columns = [
    { title: "Id", type: "number", isVisible: false, key: "id" },
    {
      title: "Name",
      type: "text",
      isVisible: true,
      key: "name",
    },
    {
      title: "Phone Number",
      type: "text",
      isVisible: true,
      key: "phone",
    },
    {
      title: "Master Tournament",
      type: "text",
      isVisible: true,
      key: "masterTournamentName",
    },
    {
      title: "Last Login",
      type: "text",
      isVisible: true,
      key: "lastLogin",
    },
    {
      title: "Created On",
      type: "text",
      isVisible: true,
      key: "createdOn",
    },
  ];

  const _addBtn = () => (
    <AddTournamentUmpire
      id={refId}
      onClose={() => getData()}
      open={open}
      setOpen={setOpen}
    />
  );

  return (
    <>
      {data?.data && (
        <AdvanceTable
          title={"Tournament Umpires"}
          columns={columns.filter((item) => item.isVisible)}
          data={data}
          getData={getData}
          addButton={_addBtn}
          showPagination
          showAddButton
          actionButtons={actions}
        />
      )}
    </>
  );
};

export default TournamentUmpires;
